import React from "react";
import { Link } from "react-router-dom";
import { useConfirm } from "../../context/ConfirmContext";
import "./style.css";

// Importação das imagens
import imagemEntrada from "../../assets/imagem-entrada.webp";
import imagemSaida from "../../assets/imagem-saida.webp";
import imagemCadastrar from "../../assets/identidade-digital.webp";
import imagemAutorizarEntrada from "../../assets/agenda.webp";
import imagemAutorizarSaida from "../../assets/imagem-autorizar-saida.webp";
import imagemCentralControle from "../../assets/central-controle.webp";

const Navbar = () => {
    const userType = Number(localStorage.getItem("userType"));
    const fullName = localStorage.getItem("fullName") || "";
    const firstName = fullName.split(" ")[0];
    const { showConfirm } = useConfirm();

    const handleLogout = () => {
        showConfirm("Deseja realmente sair do sistema?", () => {
            localStorage.clear();
            window.location.href = "/login";
        });
    };

    /**
     * Configuração dos links da navbar.
     * Cada item define:
     * - path: rota do link
     * - label: texto exibido
     * - icon: imagem
     * - allowedUsers: array com os tipos de usuário que podem ver o link
     */
    const navLinksConfig = [
        {
            path: "/central-controle",
            label: "Central de Controle",
            icon: imagemCentralControle,
            allowedUsers: [3],
        },
        {
            path: "/cadastro-pessoa",
            label: "Cadastrar Pessoa",
            icon: imagemCadastrar,
            allowedUsers: [1, 3],
        },
        {
            path: "/registro-entrada",
            label: "Registrar Entrada",
            icon: imagemEntrada,
            allowedUsers: [1, 3, 4],
        },
        {
            path: "/registro-saida",
            label: "Registrar Saída",
            icon: imagemSaida,
            allowedUsers: [1, 3, 4],
        },
        {
            path: "/autorizacao-entrada",
            label: "Agendar Visitante",
            icon: imagemAutorizarEntrada,
            allowedUsers: [2, 3, 4],
        },
        {
            path: "/autorizacao-saida",
            label: "Autorizar Saída",
            icon: imagemAutorizarSaida,
            allowedUsers: [2, 3, 4],
        },
    ];

    // Filtra os links que o tipo de usuário atual pode ver
    const availableLinks = navLinksConfig.filter((link) =>
        link.allowedUsers.includes(userType)
    );

    return (
        <div className="navbar-completa">
            <div className="navbar">
                {availableLinks.map(({ path, label, icon }) => (
                    <Link key={path} to={path} className="nav-button">
                        <img src={icon} alt={label} className="nav-icon" />
                        <span>{label}</span>
                    </Link>
                ))}
            </div>

            <div className="nav-welcome">
                Olá, {firstName}
                <button className="logout-button" onClick={handleLogout}>
                    Logout
                </button>
            </div>
        </div>
    );
};

export default Navbar;
